import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import '../Pagination.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { runMdMutation, isMdMutationLocked } from '../../services/mdMutationGuard';
import { MD_PAGE_SIZE, fetchAndApplyIndexPage } from '../../services/mdServerIndex';
import { ConfirmDialog } from '../common/ConfirmDialog';
import {
    buildStandardRowActions,
    MdRowActions,
    MdTableActionsCell,
    MdTableHeaderCell,
} from '../common/MdRowActions';
import { PlusIcon, SearchIcon } from '../common/mdPageIcons';

function formatPeriodoCursada(value) {
    if (value === '1') return 'Primer Cuatrimestre';
    if (value === '2') return 'Segundo Cuatrimestre';
    return 'Anual';
}

function canGenerarActa(cursada) {
    const fin = new Date(cursada.periodoCursadaFinInscripcion);
    fin.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return fin < today && cursada.generarActa;
}

export class MDCursadas extends Component {
    static displayName = MDCursadas.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            searchInput: '',
            perPage: MD_PAGE_SIZE,
            paginationData: [],
            totalCount: 0,
            pageCount: 0,
            offset: 0,
            currentPage: 0,
            showErrorMessage: false,
            errorMessage: '',
            successMessage: '',
            deletingId: null,
            generatingId: null,
            pendingDelete: null,
            pendingActa: null,
        };
        this.searchInputRef = React.createRef();
    }

    componentDidMount() {
        if (constantClass.canAccess('WWCursada')) {
            this.populateData();
        }
    }

    handleRemoveItem = (cursada) => {
        if (isMdMutationLocked(this)) return;
        this.setState({
            pendingDelete: {
                id: cursada.cursadaCod,
                nombre: cursada.materiaNombre,
                carrera: cursada.carreraNombre
      },
        });
    };

    handleGenerarActaRequest = (cursada) => {
        if (isMdMutationLocked(this)) return;
        this.setState({
            pendingActa: {
                id: cursada.cursadaCod,
                nombre: cursada.materiaNombre,
                carrera: cursada.carreraNombre
            },
        });
    };

    handleCancelDelete = () => {
        if (this.state.deletingId) return;
        this.setState({ pendingDelete: null });
    };

    handleConfirmDelete = () => {
        const { pendingDelete } = this.state;
        if (!pendingDelete || isMdMutationLocked(this)) return;
        this.deleteItem(pendingDelete.id);
    };

    handleCancelActa = () => {
        if (this.state.generatingId) return;
        this.setState({ pendingActa: null });
    };

    handleConfirmActa = () => {
        const { pendingActa } = this.state;
        if (!pendingActa || isMdMutationLocked(this)) return;
        this.generarActa(pendingActa.id);
    };

    handlePageClick = (e) => {
        this.populateData(e.selected, this.state.searchInput);
    };

    handleSearchInputChange = (e) => {
        const searchInput = e.target.value;
        const cleared = searchInput.trim() === '';
        this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });
        if (cleared && this.state.searchInput.trim() !== '') {
            this.populateData(0, '', { background: false });
        }
    };

    clearFeedback = () => {
        this.setState({ successMessage: '', showErrorMessage: false, errorMessage: '' });
    };

    handleSearchSubmit = (e) => {
        e.preventDefault();
        const search = (this.searchInputRef.current
            ? this.searchInputRef.current.value
            : this.state.searchInput).trim();
        this.setState({ searchInput: search });
        this.populateData(0, search, { background: false });
    };

    buildRowActions(cursada) {
        const id = cursada.cursadaCod;
        const extraActions = [];

        if (canGenerarActa(cursada)) {
            extraActions.push({
                key: 'acta',
                label: this.state.generatingId === id ? 'Generando...' : 'Acta',
                variant: 'primary',
                icon: 'document',
                onClick: () => this.handleGenerarActaRequest(cursada),
                disabled: this.state.loading || this.state.generatingId === id,
            });
        }

        return buildStandardRowActions({
            editTo: '/update-cur/' + id + '/0',
            onDelete: () => this.handleRemoveItem(cursada),
            deleteDisabled: this.state.loading || this.state.deletingId === id,
            deleteLabel: this.state.deletingId === id ? 'Eliminando...' : 'Borrar',
            detailTo: '/update-cur/' + id + '/1',
            extraActions,
        });
    }

    renderTable(cursadas) {
        return (
            <div className="md-page__table-card">
                <table className="md-page__table md-page__table--actions-fixed md-cursadas__table" aria-labelledby="md-cursadas-title">
                    <colgroup>
                        <col className="md-cursadas__col-materia" />
                        <col className="md-cursadas__col-carrera" />
                        <col className="md-cursadas__col-periodo" />
                        <col className="md-cursadas__col-anio" />
                        <col className="md-cursadas__col-inicio-inscripcion" />
                        <col className="md-cursadas__col-fin-inscripcion" />
                        <col className="md-cursadas__col-actions" />
                    </colgroup>
                    <thead>
                        <tr>
                            <MdTableHeaderCell cellType="text" className="md-cursadas__cell md-cursadas__cell--materia">Materia</MdTableHeaderCell>
                            <MdTableHeaderCell cellType="text" className="md-cursadas__cell md-cursadas__cell--carrera">Carrera</MdTableHeaderCell>
                            <MdTableHeaderCell cellType="text" className="md-cursadas__cell md-cursadas__cell--periodo">Período de Cursada</MdTableHeaderCell>
                            <MdTableHeaderCell cellType="number" className="md-cursadas__cell md-cursadas__cell--anio">Año Académico</MdTableHeaderCell>
                            <MdTableHeaderCell cellType="date" className="md-cursadas__cell md-cursadas__cell--inicio-inscripcion">Inicio Inscripción</MdTableHeaderCell>
                            <MdTableHeaderCell cellType="date" className="md-cursadas__cell md-cursadas__cell--fin-inscripcion">Fin Inscripción</MdTableHeaderCell>
                            <th scope="col" className="md-page__table__actions-header" aria-label="Acción" />
                        </tr>
                    </thead>
                    <tbody>
                        {cursadas.map((cursada) => (
                            <tr key={cursada.cursadaCod}>
                                <td className="md-cursadas__cell md-cursadas__cell--materia md-page__table__cell--text">{cursada.materiaNombre}</td>
                                <td className="md-cursadas__cell md-cursadas__cell--carrera md-page__table__cell--text">{cursada.carreraNombre}</td>
                                <td className="md-cursadas__cell md-cursadas__cell--periodo md-page__table__cell--text">{formatPeriodoCursada(cursada.periodoCursadaDescripcion)}</td>
                                <td className="md-cursadas__cell md-cursadas__cell--anio md-page__table__cell--number">{cursada.anioAcademicoDescripcion}</td>
                                <td className="md-cursadas__cell md-cursadas__cell--inicio-inscripcion md-page__table__cell--date">{constantClass.formatDisplayDate(cursada.periodoCursadaInicioInscripcio)}</td>
                                <td className="md-cursadas__cell md-cursadas__cell--fin-inscripcion md-page__table__cell--date">{constantClass.formatDisplayDate(cursada.periodoCursadaFinInscripcion)}</td>
                                <MdTableActionsCell>
                                    <MdRowActions items={this.buildRowActions(cursada)} />
                                </MdTableActionsCell>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        const isBusy = this.state.loading || this.state.searching;
        const listLoading = this.state.loading && !this.state.deletingId && !this.state.generatingId;
        const { pendingDelete, pendingActa } = this.state;

        const contents = listLoading
            ? <p className="md-page__loading"><em>Cargando datos...</em></p>
            : this.renderTable(this.state.paginationData);

        return (
            <div className="md-page md-cursadas">
                <h1 id="md-cursadas-title" className="md-page__title">Manejar Datos de Cursadas</h1>

                <div className="md-page__feedback" aria-live="polite" role="status">
                    {this.state.showErrorMessage ? (
                        <div className="md-page__error" role="alert">
                            {this.state.errorMessage}
                        </div>
                    ) : null}
                    {this.state.successMessage ? (
                        <div className="md-page__success">{this.state.successMessage}</div>
                    ) : null}
                </div>

                <div className="md-page__toolbar">
                    <Link className="md-page__action-link" to="/add-cur">
                        <PlusIcon />
                        Nueva Cursada
                    </Link>
                    <Link className="md-page__action-link" to="/gen-cur">
                        <PlusIcon />
                        Generar Cursadas
                    </Link>
                </div>

                <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
                    <div className="md-page__search-wrap">
                        <span className="md-page__search-icon">
                            <SearchIcon />
                        </span>
                        <input
                            ref={this.searchInputRef}
                            className="md-page__search-input"
                            type="text"
                            name="search"
                            autoComplete="off"
                            disabled={isBusy}
                            placeholder="Ingrese el período de cursada o la materia"
                            value={this.state.searchInput}
                            onChange={this.handleSearchInputChange}
                        />
                    </div>
                    <button type="submit" className="md-page__search-btn" disabled={isBusy}>
                        Buscar
                    </button>
                </form>

                {contents}

                {!listLoading && this.state.pageCount > 0 ? (
                    <div className="md-page__pagination">
                        <ReactPaginate
                            previousLabel="Anterior"
                            nextLabel="Siguiente"
                            breakLabel="..."
                            breakClassName="break-me"
                            pageCount={this.state.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            forcePage={Math.floor(this.state.offset / this.state.perPage)}
                            onPageChange={this.handlePageClick}
                            containerClassName="pagination"
                            subContainerClassName="pages pagination"
                            activeClassName="active"
                        />
                    </div>
                ) : null}

                <ConfirmDialog
                    open={Boolean(pendingDelete)}
                    title="Eliminar cursada"
                    message="Esta acción eliminará la cursada del sistema y no se puede deshacer."
                    detail={pendingDelete ? pendingDelete.nombre - pendingDelete.carrera : ''}
                    confirmLabel="Eliminar"
                    cancelLabel="Cancelar"
                    variant="danger"
                    loading={Boolean(this.state.deletingId)}
                    onConfirm={this.handleConfirmDelete}
                    onCancel={this.handleCancelDelete}
                />

                <ConfirmDialog
                    open={Boolean(pendingActa)}
                    title="Generar acta de cursada"
                    message="Se generará el acta de cursada para esta materia. ¿Desea continuar?"
                    detail={pendingActa ? pendingActa.nombre - pendingActa.carrera : ''}
                    confirmLabel="Generar"
                    cancelLabel="Cancelar"
                    variant="primary"
                    loading={Boolean(this.state.generatingId)}
                    onConfirm={this.handleConfirmActa}
                    onCancel={this.handleCancelActa}
                />
            </div>
        );
    }

    async populateData(page = 0, search = '', options = {}) {
        await fetchAndApplyIndexPage(this, {
            indexUrl: 'api/cur/Index',
            page,
            search: typeof search === 'string' ? search.trim() : '',
            perPage: this.state.perPage,
            background: options.background,
        });
    }

    async deleteItem(id) {
        this.clearFeedback();
        this.setState({ deletingId: id });
        await runMdMutation(this, async () => {
            const { data } = await constantClass.apiFetch('api/cur/delete/' + id, {
                method: 'POST',
            });
            if (data === 'Timeout') {
                constantClass.RedirectToLogin();
                return;
            }
            if (constantClass.isApiError(data) || data.returnModel === false) {
                this.setState({
                    showErrorMessage: true,
                    errorMessage: constantClass.getApiErrorMessage(
                        data,
                        'No se pudo eliminar la cursada. Verifique si tiene registros asociados e intente nuevamente.'
                    ),
                    pendingDelete: null,
                });
                return;
            }
            this.setState({ successMessage: 'La cursada se eliminó correctamente.', pendingDelete: null });
            await this.populateData(this.state.currentPage, this.state.searchInput);
        });
        this.setState({ deletingId: null });
    }

    async generarActa(id) {
        this.clearFeedback();
        this.setState({ generatingId: id });
        await runMdMutation(this, async () => {
            const { data } = await constantClass.apiFetch('api/acur/generate/' + id, {
                method: 'POST',
            });
            if (data === 'Timeout') {
                constantClass.RedirectToLogin();
                return;
            }
            if (constantClass.isApiError(data) || data === 'Forbidden.') {
                this.setState({
                    showErrorMessage: true,
                    errorMessage: constantClass.getApiErrorMessage(
                        data,
                        'No se pudo generar el acta. Intente nuevamente.'
                    ),
                    pendingActa: null,
                });
                return;
            }
            this.setState({
                successMessage: 'Acta generada correctamente. Puede imprimirla desde Actas de Cursada.',
                pendingActa: null,
            });
            await this.populateData(this.state.currentPage, this.state.searchInput);
        });
        this.setState({ generatingId: null });
    }
}
